import { useQuery } from '@tanstack/react-query';

import { useProfile } from '../profile';

import { sdk } from '@/services';

const PlanificationService = sdk.getService('PlanificationService');

export const useMyPlanificationProgress = () => {
  const { profile } = useProfile();
  const userId = profile?._id;
  const queryKey = ['planification', 'progress-chart', userId];

  const { data, isPending } = useQuery({
    queryKey,
    queryFn: () => PlanificationService.getPlanificationProgressChart(userId!),
    enabled: !!userId
  });

  return {
    planificationProgress: data,
    isPending
  };
};
